import NotificationsListModule from './notifications-list.module'

export default NotificationsListModule
